<template>
    <div style="background:white;height:100%">         
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:40px;  border-bottom:2px solid #389">
            <div style="min-width:1100px;display:flex;padding-top:3px">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px; ">{{ $LANG('0138', '新增') }}</span></el-link>
                </div>
                <span >
                    <el-radio-group v-model="stfgSet"  size="mini" @change="stfgChange(stfgSet)">
                        <el-radio  border label="ALL"  >{{ $LANG('321', '所有') }}</el-radio>
                        <el-radio border label="Y" >{{ $LANG('1946', '启用') }}</el-radio>
                        <el-radio border  label="N" >{{ $LANG('0259', '停用') }}</el-radio>
                    </el-radio-group>
                </span>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:150px;margin-left:20px; ">
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" clearable  v-model="txtparam" size="small" style="width:320px; height:30px;  ">
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " size="small">
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                </el-input> 
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div> 
        <ve-table :columns="vueCol"
                :table-data="tabData"
                :columnHiddenOption="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                :scroll-width="0"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :event-custom-option="eventCustomOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :column-width-resize-option="columnWidthResizeOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :cellSelectionOption="{enable: false}"
                ref="tabref">
        </ve-table>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
 
       
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="drawer" width="1050px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style=" overflow-y:auto">
            <el-card v-for="(gpitem,gpind) in formArr" :key="gpind" style="margin-bottom:10px;">
                <p slot="header" style="color:#5cadff;height:14px;line-height:14px ">
                    <span style="font-weight:600;font-size:14px;color:#5cadff">{{gpitem.gpnm}} </span>        
                </p>
                <Form :model="perRow" :label-width="120" ref="supForm"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in gpitem.gplist" :key="index" >
                        <FormItem  :label="item.FLDNM"  :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                            <el-date-picker :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="perRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number :disabled="saveFlag" :precision="item.DOTNUM" v-else-if="item.EDCSS==='number'" v-model="perRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                            <el-checkbox border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="perRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                            <el-select @change="comChange" :disabled="saveFlag" v-else-if="item.EDCSS==='select'" v-model="perRow[item.FLDNO]"   style="width:346px">
                                <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input  type="text" v-else-if="item.FLDNO==='BANKEMP'||item.FLDNO==='BANKNM'||item.FLDNO==='BANKNO'" :disabled="comFlag||saveFlag "  v-model="perRow[item.FLDNO]"></el-input>
                            <el-input  type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="perRow[item.FLDNO]"></el-input>
                        </FormItem>
                    </span>
                </Form>
            </el-card>

            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <div style="height:40px;line-height:30px;float:right"> 
                <span :style="stfgColor">
                    <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-right:40px;height:35px;vertical-align:middle"></i>
                </span> 
                <el-button size="small" type="info" icon="iconfont icon-shanchu"  @click="drawer=false" style="font-size:12px;margin-left:20px">{{ $LANG('0132', '取消') }}</el-button>
                <el-button size="small" type="primary" icon="iconfont icon-baocun"  @click="saveRec" style="font-size:12px;margin-left:30px">{{ $LANG('0130', '保存') }}</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promtWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promtWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate} from '../../api/Select' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
//局部注册
export default {
    name:"fin_cashno",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '14404',
            fieldIdseq: '14404',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tabref',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    components: { VeColumnConfigDialog },
    data () {
        return {
            drawer:false,
            perFlag:'create',
            comFlag:false,
            contRow:{},
            saveFlag:false,
            promtWin:false,
            prompt:'',
            stfgCss:'',
            perWin:false,
            stfgColor:'',
            perRow:{},
            menuList: [],
            openName:[], //模块ID集合
            listIndex:'-1',
            active:'', //二级菜单选中标志
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            ruleValidate:{},
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: { headerCellClass: () => 'table-head-cell-class', bodyCellClass: () => 'table-body-cell-class1' },
            v_headerRow:{},
            queryRequestId:0,
            virtualScrollOption: { enable: false },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
            },
            perData:[], //联系人
            operArr:[],
            oper:'like',
            comboArr:{},
            txtparam:'',
            selparam:'ACCNM',
            delArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:20,
            goPage:'',
            notNull:[],
            current:1,
            imgSrc:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            pageList: [ {
                value: 20,
                label: '20'
                }, {
                value: 30,
                label: '30'
                }, {
                value: 40,
                label: '40'
            }],
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','14404','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
        //表单所以下拦框动态赋值
        this.comSelect()
 
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','14404','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promtWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14404','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 300) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 130) + 'px';
        }, 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getAccList('')
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        comChange( val){
            if (val==='14409'){ //现金账户
                this.comFlag=true
                this.perRow['BANKEMP']=''
                this.perRow['BANKNM']=''
                this.perRow['BANKNO']=''
            }else if (val==='14410'){ //银行账户
                this.comFlag=false
            }
        },
        //表行点击事件
        rowClick(row){
            if (row['STFG']==='Y')  {
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'14404',p_key2:'lstseq',p_value2:'1',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.perRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promtWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {    
                let obj_ ={}      
                Object.assign(obj_,vm.perRow,{ 'CORPID':this.v_corpid}) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'AC_ACCOUNT',p_idseq:''},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        vm.drawer =false   
                        vm.getAccList('')
                    }else{
                        this.promtWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },
        //状态审核
        recSet(row,val){
            let stfg_ =val==='Y'?this.$LANG('1946', '启用'): this.$LANG('0259', '停用')
            this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1568', '此账户名称吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                let cond_=''
                cond_=' set stfg=\''+val+'\''
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ, p_table:'AC_ACCOUNT',p_cond:cond_ },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        vm.qryTabData()     
                    }else{
                        this.promtWin=true
                        this.prompt=res.message
                    }        
                }) 
                 
            }).catch(()=>{})
        },
        //账户明细
        getAccList(cond){
            const requestId = ++this.queryRequestId
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_AC_ACCOUNT'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.tabData =res.result
 
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => {
                    const table = this.$refs.tabref
                    if (table && typeof table.doLayout === 'function') table.doLayout()
                })
            }).catch((error) => {
                if (requestId === this.queryRequestId) { this.promtWin=true; this.prompt=error.message || this.$LANG('1641', '查询失败') }
            })
        },
 
  
 
        editRec(row,val){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
               this.saveFlag=false
            }
            this.perRow =JSON.parse(JSON.stringify(row))
            this.drawer=true 
            if (row['ACCTY']==='14409'){ //现金账户
                this.comFlag=true
            }else { //银行账户
                this.comFlag=false
            }          
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let cond_=buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
            cond_+=buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
 
            if (this.stfgSet=='ALL'){
                this.getAccList(cond_)
            }else if (this.stfgSet=='Y'){ //启用
                this.getAccList(' and stfg=\'Y\''+ cond_)
            }else if (this.stfgSet=='N'){ //停用
                this.getAccList(' and stfg=\'N\''+ cond_)
            }
        },
        rowShow(){
            this.v_headerRow = {}
            this.qryTabData()
        },
        //新增客户
        addRec(){
            this.drawer =true
            this.stfgCss='icon-weishenhe3'
            this.perRow={ACCTY:'14409',AMT:'0',DTTM:getDate('day')}
            this.comFlag=true
            this.saveFlag=false
        },
        //状态查询
        stfgChange(){
            this.qryTabData()
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','14404','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.tabArr = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        vm.tabArr.push({
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            edcss: item.EDCSS,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            disabled: item.DISABLED,
                        })
                        if (item.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: item.key,
                            key: item.key,
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            align: item.align,
                            width: Number(item.width) || 120,
                            sortable: item.key !== 'RN' && item.EDCSS !== 'checkbox',
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column}) => <VeTableQueryHeader title={column.title} edcss={item.EDCSS} value={this.v_headerRow[item.key]} operator={this.v_headerRow[`#OPER${item.key}`]} options={this.comboArr[item.key] || []} on-input={(value) => this.$set(this.v_headerRow, item.key, value)} on-operator-change={(value) => this.$set(this.v_headerRow, `#OPER${item.key}`, value)} on-query={this.qryTabData} />,
                            renderBodyCell: ({row}) => item.EDCSS === 'checkbox'
                                ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                : row[item.key],
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 55,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '操作'),
                        width: 170,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row}) => (
                            <div>
                                <i class="iconfont icon-chazhao" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={vm.disabled} on-click={() => vm.editRec(row, 'Y')} underline={false}><span style="font-size:11px;margin-right:5px;">{vm.$LANG('0139', '查看')}</span></el-link>
                                <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link disabled={vm.editBool} on-click={() => vm.editRec(row, 'N')} underline={false}><span style="font-size:11px;margin-right:5px;">{vm.$LANG('1639', '编辑')}</span></el-link>
                                {row.STFG !== 'Y' ? (
                                    <span><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={vm.cfmBool} on-click={() => vm.recSet(row, 'Y')} underline={false}><span style="font-size:11px;margin-right:5px;">{vm.$LANG('1946', '启用')}</span></el-link></span>
                                ) : (
                                    <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={vm.cfmBool} on-click={() => vm.recSet(row, 'N')} underline={false}><span style="font-size:11px;margin-right:5px;">{vm.$LANG('0259', '停用')}</span></el-link></span>
                                )}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
